import React from "react";
import ToolOutput from "./ToolOutput";
export default function GenericToolCard({ payload, result }) {
  return (
    <div className="tool-card-body">
      <div className="tool-section">
        <h5>Input</h5>
        <pre className="tool-pre">{JSON.stringify(payload?.input ?? {}, null, 2)}</pre>
      </div>
      {result && (
        <div className="tool-section">
          <h5>Output {result.is_error ? "(error)" : ""}</h5>
          <ToolOutput text={result.content_preview} />
        </div>
      )}
    </div>
  );
}
GenericToolCard.summarize = (p) => p?.name || "tool call";
